import { render, staticRenderFns } from "./MirageLogo.vue?vue&type=template&id=85a45b64&scoped=true&"
var script = {}
import style0 from "./MirageLogo.vue?vue&type=style&index=0&id=85a45b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a45b64",
  null
  
)

export default component.exports